export enum DigitalWalletTypeEnum {
  GOOGLE_PAY = '503',
  APPLE_PAY = '504'
}
